import { createPluginFactory } from '@udecode/plate-common';

import { withMCENormalizer } from './withMCENormalizer';

export const KEY_NORMALIZE_MCE = 'normalizeMCE';

/**
 * Enables support for deserializing inserted content from HTML format to Slate format.
 */
export const createMCENormalizerPlugin = createPluginFactory({
  key: KEY_NORMALIZE_MCE,
  withOverrides: withMCENormalizer,
});
